/**
 * Notification Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UnsubscribeRequestDto { 
    token?: string;
    scope?: UnsubscribeRequestDto.ScopeEnum;
}
export namespace UnsubscribeRequestDto {
    export const ScopeEnum = {
        All: 'ALL',
        Collar: 'COLLAR'
    } as const;
    export type ScopeEnum = typeof ScopeEnum[keyof typeof ScopeEnum];
}


export type ScopeEnum = typeof UnsubscribeRequestDto.ScopeEnum[keyof typeof UnsubscribeRequestDto.ScopeEnum];
